import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const AddressModal = ({ isOpen, onClose, mode, editData, refreshList }) => {
  const USER_ID = localStorage.getItem("user_id");
  console.log("USER_ID:", USER_ID);
  console.log("Edit Data Received:", editData);
  console.log("Mode:", mode);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    address: "",
    location: "",
    city: "",
    state: "",
    pincode: "",
    landmark: "",
    address_type: "Home",
    is_default: "1",
    payment_mode: "Cash",
    total: "0.00",
    discount_MRP: "0.00",
    total_discount: "0.00",
  });

  /* =========================
     PREFILL EDIT DATA
  ========================== */
  useEffect(() => {
    if (mode === "edit" && editData) {
      console.log("Prefilling form with:", editData);
      setFormData({
        name: editData.name || "",
        phone: editData.phone || "",
        address: editData.address || "",
        location: editData.location || "",
        city: editData.city || "",
        state: editData.state || "",
        pincode: editData.pincode || "",
        landmark: editData.landmark || "",
        address_type: editData.address_type || "Home",
        is_default: editData.is_default || "1",
        payment_mode: editData.payment_mode || "Cash",
        total: editData.total || "0.00",
        discount_MRP: editData.discount_MRP || "0.00",
        total_discount: editData.total_discount || "0.00",
      });
    } else if (mode === "add") {
      // Reset form for add mode
      setFormData({
        name: "",
        phone: "",
        address: "",
        location: "",
        city: "",
        state: "",
        pincode: "",
        landmark: "",
        address_type: "Home",
        is_default: "1",
        payment_mode: "Cash",
        total: "0.00",
        discount_MRP: "0.00",
        total_discount: "0.00",
      });
    }
  }, [mode, editData, isOpen]);

  console.log("Current FORM DATA:", formData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  /* =========================
     STRONG VALIDATION
  ========================== */
  const validateForm = () => {
    // Name validation
    if (!formData.name.trim()) {
      toast.error("Name is required");
      return false;
    }

    if (!/^[A-Za-z\s]+$/.test(formData.name)) {
      toast.error("Name should contain only letters");
      return false;
    }

    if (formData.name.trim().length < 3) {
      toast.error("Name must be at least 3 characters");
      return false;
    }

    // Phone validation
    if (!formData.phone.trim()) {
      toast.error("Mobile number is required");
      return false;
    }

    if (!/^[6-9]\d{9}$/.test(formData.phone)) {
      toast.error("Enter valid 10 digit mobile number starting with 6-9");
      return false;
    }

    // Address validation
    if (!formData.address.trim()) {
      toast.error("Address is required");
      return false;
    }

    if (formData.address.trim().length < 10) {
      toast.error("Address must be at least 10 characters");
      return false;
    }

    // Location validation
    if (!formData.location.trim()) {
      toast.error("Location is required");
      return false;
    }

    if (formData.location.trim().length < 2) {
      toast.error("Location must be at least 2 characters");
      return false;
    }

    // City validation
    if (!formData.city.trim()) {
      toast.error("City is required");
      return false;
    }

    if (!/^[A-Za-z\s]+$/.test(formData.city)) {
      toast.error("City should contain only letters");
      return false;
    }

    if (formData.city.trim().length < 2) {
      toast.error("City must be at least 2 characters");
      return false;
    }

    // State validation
    if (!formData.state.trim()) {
      toast.error("State is required");
      return false;
    }

    if (!/^[A-Za-z\s]+$/.test(formData.state)) {
      toast.error("State should contain only letters");
      return false;
    }

    if (formData.state.trim().length < 2) {
      toast.error("State must be at least 2 characters");
      return false;
    }

    // Pincode validation
    if (!formData.pincode.trim()) {
      toast.error("Pincode is required");
      return false;
    }

    if (!/^\d{6}$/.test(formData.pincode)) {
      toast.error("Enter valid 6 digit pincode");
      return false;
    }

    return true;
  };

  /* =========================
     SUBMIT (ADD / UPDATE)
  ========================== */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!USER_ID) {
      toast.error("Please login first");
      return;
    }

    if (!validateForm()) return;

    try {
      let url, payload;

      if (mode === "edit") {
        url = "https://cyberathon.com/streekatha/API/index.php/Master_controller/update_contact_details_address";
        
        payload = {
          contact_id: String(editData.contact_id),
          user_id: String(USER_ID),
          name: formData.name,
          phone: formData.phone,
          pincode: formData.pincode,
          address: formData.address,
          location: formData.location,
          city: formData.city,
          state: formData.state,
          address_type: formData.address_type,
          is_default: formData.is_default,
          total: formData.total,
          discount_MRP: formData.discount_MRP,
          total_discount: formData.total_discount,
          payment_mode: formData.payment_mode,
          landmark: formData.landmark || "",
          created_at: editData.created_at || "",
          updated_at: new Date().toISOString().slice(0, 19).replace('T', ' ')
        };
      } else {
        url = "https://cyberathon.com/streekatha/API/index.php/Master_controller/add_contact_details_address";
        
        payload = {
          user_id: String(USER_ID),
          name: formData.name,
          phone: formData.phone,
          pincode: formData.pincode,
          address: formData.address,
          location: formData.location,
          city: formData.city,
          state: formData.state,
          address_type: formData.address_type,
          is_default: formData.is_default,
          total: formData.total,
          discount_MRP: formData.discount_MRP,
          total_discount: formData.total_discount,
          payment_mode: formData.payment_mode,
          landmark: formData.landmark || ""
        };
      }

      console.log("Submitting payload:", payload);

      const res = await axios.post(url, payload, {
        headers: { 
          "Content-Type": "application/json"
        },
      });

      console.log("API Response:", res.data);

      if (res.data.status === "true" || res.data.status === true || res.data.success === "1") {
        toast.success(
          mode === "edit"
            ? "Address updated successfully"
            : "Address added successfully"
        );
        refreshList();
        onClose();
      } else {
        toast.error(res.data.message || "Operation failed");
      }
    } catch (error) {
      console.error("Address submit error:", error);
      if (error.response) {
        console.error("Error response:", error.response.data);
        toast.error(error.response.data.message || "Server error");
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  if (!isOpen) return null;

  return (
    <div className="login-modal-overlay" onClick={onClose}>
      <div className="login-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="login-modal-close" onClick={onClose}>
          ✕
        </button>

        <div className="login-modal-body">
          <div className="login-modal-form-section">
            <div className="login-modal-header">
              {mode === "edit" ? "Edit Address" : "Add New Address"}
            </div>

            <form onSubmit={handleSubmit} className="login-modal-form">
              <label>Name *</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your name"
                required
              />

              <label>Phone *</label>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter 10 digit mobile number"
                maxLength="10"
                required
              />

              <label>Address *</label>
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
                placeholder="Enter your address"
                required
              />

              <label>Location *</label>
              <input
                type="text"
                name="location"
                value={formData.location}
                onChange={handleChange}
                placeholder="Enter location"
                required
              />

              <label>City *</label>
              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                placeholder="Enter city"
                required
              />

              <label>State *</label>
              <input
                type="text"
                name="state"
                value={formData.state}
                onChange={handleChange}
                placeholder="Enter state"
                required
              />

              <label>Pincode *</label>
              <input
                type="text"
                name="pincode"
                value={formData.pincode}
                onChange={handleChange}
                placeholder="Enter 6 digit pincode"
                maxLength="6"
                required
              />

              <label>Landmark</label>
              <input
                type="text"
                name="landmark"
                value={formData.landmark}
                onChange={handleChange}
                placeholder="Enter landmark (optional)"
              />

              <label>Address Type *</label>
              <select
                name="address_type"
                value={formData.address_type}
                onChange={handleChange}
                required
              >
                <option value="Home">Home</option>
                <option value="Office">Office</option>
              </select>

              <button type="submit" className="login-modal-continue">
                {mode === "edit" ? "UPDATE ADDRESS" : "ADD ADDRESS"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddressModal;